<div class="popup-container">
  
    <div class="modal-header">
      <span class="modal-title header-13">{{ data.title }}</span>
    
  <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        "
      />
    </button>
    </div>
    
  <div *ngIf="isDataLoaded" class="popup-body ">
    <div class="w-46 mb-3">
      <div class="accello-general-text6 mb-1">Test Schedule Name</div>
      <input
        class="name-field form-control"
        type="text"
        [(ngModel)]="scheduleName"
        placeholder="Test Schedule Name"
      />
    </div>
    <div class="row px-0 mx-0">
      <div class="col">
        <div class="row accello-general-text6">Test Plans</div>
        <div class="row pt-0 search-container">
          <input
            type="text"
            class="search-input form-control"
            [(ngModel)]="searchPlan"
            (keyup)="modifyPlansList()"
            placeholder="Search test plans"
          />
        </div>
        <div class="row plans-list">
          <div
            class="row mx-0 px-2 plan"
            *ngFor="let plan of planSearchResults"
            [ngClass]="selectedPlan?.id == plan.id ? 'active-plan' : ''"
            (click)="updateSelected(plan)"
            (keydown.enter)="updateSelected(plan)"
          >
            {{ plan.name }}
          </div>
        </div>
      </div>
      <div class="col-1">
        <div
          class="d-flex flex-column justify-content-center align-items-center row h-100 arrows-container"
        >
          <button
            class="arrow-btn mb-2"
            (click)="moveSelected()"
            [disabled]="!selectedPlan"
          >
            <img
              src="assets/images/virtusa-icons/arrow-right.svg"
              alt="arrow-icon"
              class="button-icon"
            />
          </button>

          <button
            class="arrow-btn"
            (click)="moveSelected('remove')"
            [disabled]="planIndexToRemove < 0"
          >
            <img
              src="assets/images/virtusa-icons/arrow-left.svg"
              alt="arrow-icon"
              class="button-icon"
            />
          </button>
        </div>
      </div>
      <div class="col accello-general-text6">
        <div>Selected Test Plans</div>
        <div class="pt-0 search-container">
          <input
            type="text"
            class="search-input form-control"
            [(ngModel)]="searchSelectedPlan"
            (keyup)="modifySelectedList()"
            placeholder="Search selected test plans"
          />
        </div>
        <div class="plans-list selected-plans">
          @for (plan of selectedPlansSearchResults; track plan; let i = $index)
          {
          <div
            class="row mx-0 px-0 plan"
            [ngClass]="i == planIndexToRemove ? 'active-plan' : ''"
            (click)="updatePlanToRemove(i)"
            (keydown.enter)="updatePlanToRemove(i)"
          >
            <!-- <mat-icon class="folder-icon">folder</mat-icon> -->
            <span class="mx-2">{{ plan.name }}</span>
          </div>
          }
        </div>
      </div>
    </div>
    <div class="w-46 mb-3">
      <div class="accello-general-text6 mb-1">Cron Expression</div>
      <input
        class="name-field form-control"
        type="text"
        [(ngModel)]="cronExpression"
        placeholder="Cron Expression"
        (blur)="validateCron()"
      />
      <div *ngIf="cronError" class="text-danger">{{ cronError }}</div>
      <div *ngIf="cronDescription" class="text-infor">
        {{ cronDescription }}
      </div>
    </div>
    <div class="d-flex button-space mx-0 justify-content-end">
      <button
        type="button"
        class="btn-accello-secondary mx-2"
        (click)="closePopup()"
      >
        Cancel
      </button>
      <button
        type="button"
        class="btn-accello-primary-light"
        [class]="
          !selectedPlans.length || scheduleName.trim() == ''
            ? 'not-allowed'
            : ''
        "
        [disabled]="
          !selectedPlans.length || scheduleName.trim() === '' || !isCronValid
        "
        (click)="saveSchedule()"
      >
        {{ data.id ? "Update" : "Add" }}
      </button>
    </div>
  </div>
  <div *ngIf="!isDataLoaded" class="load-wrap v-center h-100">
    <app-loading [text]="'Loading data'"></app-loading>
  </div>
</div>
